<div class="stocktake-entry-count-list-grid">
    <app-generic-data-grid #stocktakeEntryCountListDataGrid
        [dataSourceConfig]="stocktakeEntryCountListDataSourceConfig"
        [joinTableColumnConfig]="stocktakeEntryCountJoinTableColumnConfig"
        [dataGridConfig]="stocktakeEntryCountListDataGridConfig"
        [dataGridActionColumn]="stocktakeEntryCountListDataGridActionColumn">
    </app-generic-data-grid>
</div>